import React from "react";

type KpiCardProps = {
  colors: {
    text: string;
    bg: string;
    bd: string;
  };
  item: {
    title: string;
    amount: any;
    icon: string;
  };
};

const KpiCard: React.FC<KpiCardProps> = ({ colors, item }) => {
  return (
    <div
      className={`rounded-md p-2 px-3 flex justify-between items-center ${colors.bg}`}
    >
      <div className="flex flex-col">
        <p className={`m-0 text-xs ${colors.text} `}>{item.title}</p>
        <p className="m-0 text-md font-semibold text-black">
          {item.amount ?? "---"}
        </p>
      </div>
      <div className="">
        <i className={`${item.icon} ${colors.text} text-xl`}></i>
      </div>
    </div>
  );
};

export default KpiCard;
